import { ConfigProvider, Form, Input } from 'antd'
import { useLingui } from '@lingui/react/macro'

import type { FormInstance } from 'antd'
import type { MusicGeneratorFormValuesNew } from '@/pages/tad.ai/ai-music-generator/_types/form'

import {
  GenerateLyricsSmartType,
  useAiMusicGeneratorStoreFromZustand,
} from '@/pages/tad.ai/ai-music-generator/_store/createStore'
import { AI_MUSIC_GENERATOR_MAX_PROMPT_LENGTH } from '@/pages/tad.ai/ai-music-generator/const'
import { EFeatureName, useFeatureGuard } from '@/hooks/usageValidation'


import { useState, useMemo } from 'react';
import { cls } from 'tagged-classnames-free';
export interface IMoreIdeaInputProps {
  className?: string
  form: FormInstance<MusicGeneratorFormValuesNew>
}

export const MoreIdeaInput = (props: IMoreIdeaInputProps) => {
  const { className, form } = props
  const { t } = useLingui()
  const {
    isStream,
    generateLyricsSmart,
    lyricsTextareaContent,
    lyricsCustomTextareaContent,
  } = useAiMusicGeneratorStoreFromZustand()
  const prompt = Form.useWatch(['prompt'], form)
  const thinking = Form.useWatch(['thinking'], form)
  const imageUrl = Form.useWatch(['imageUrl'], form)
  const promptTabsMode = Form.useWatch(['promptTabsMode'], form)
  const guardGenerate = useFeatureGuard(EFeatureName.Generate, {
    triggerMethod: 'ai_music_check',
  })

  const [moreIdeas, setMoreIdeas] = useState('')
  const btnDisabled = useMemo(() => {
    return (
      isStream ||
      !moreIdeas.trim() ||
      moreIdeas.length > AI_MUSIC_GENERATOR_MAX_PROMPT_LENGTH
    )
  }, [isStream, moreIdeas])

  const handleClick = guardGenerate(() => {
    if (btnDisabled) return

    generateLyricsSmart({
      type: GenerateLyricsSmartType.POLISH,
      formType: promptTabsMode,
      prompt: prompt || '',
      thinking,
      imageUrl,
      lyrics:
        promptTabsMode === 'custom'
          ? lyricsCustomTextareaContent
          : lyricsTextareaContent,
      polishPrompt: moreIdeas.trim(),
      generateLyricsFinishCallback: () => {},
    })
  })

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            colorBgContainer: 'bg-f-bg-elevated',
            activeBg: 'bg-f-bg-elevated',
          },
        },
      }}
    >
      <Input
        placeholder={t`Enter your idea`}
        className={className}
        value={moreIdeas}
        onChange={(e) => setMoreIdeas(e.target.value)}
        onPressEnter={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
        suffix={
          <div
            className={`bg-f-primary-style-6 relative z-20 flex size-8 cursor-pointer items-center justify-center rounded-full transition-opacity active:opacity-40 ${
              !btnDisabled ? 'opacity-100' : 'opacity-40'
            }`}
            onClick={handleClick}
            onMouseDown={(e) => {
              e.stopPropagation()
              e.preventDefault()
            }}
          >
            <span
              className={cls`
                i-com--up-arrow
                text-f-text
                size-5
              `}
            ></span>
          </div>
        }
      />
    </ConfigProvider>
  )
}
